module.exports = __webpack_public_path__ + "img/facebook.b8ec997e.svg";